import domain from "@/environment";
import axios from "axios";

const state = {
  pipeline: null,
  pipelineLoading: false,
  pipelinesForForm: [],
};

const getters = {
  getPipeline: (state) => state.pipeline,
  getPipelineLoading: (state) => state.pipelineLoading,
  getPipelinesForForm: (state) => state.pipelinesForForm,
};

const mutations = {
  SET_PIPELINE(state, payload) {
    state.pipeline = payload;
  },
  SET_PIPELINE_LOADING(state, payload) {
    state.pipelineLoading = payload || false;
  },
  SET_PIPELINES_FOR_FORM(state, payload) {
    state.pipelinesForForm = Array.isArray(payload) ? payload : [];
  },
};

const actions = {
  async getPipeline({ commit }, payload = {}) {
    commit("SET_PIPELINE_LOADING", true);
    const params = {};
    if (payload.entreprise_id != null) params.entreprise_id = payload.entreprise_id;
    if (payload.operation != null) params.operation = payload.operation;
    if (payload.client_id != null) params.client_id = payload.client_id;
    if (payload.dossier_id != null) params.dossier_id = payload.dossier_id;
    if (payload.processus_id != null) params.processus_id = payload.processus_id;
    try {
      const response = await axios.get(domain + "/pipeline", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PIPELINE", data);
      commit("SET_PIPELINE_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async updatePipeline({ commit }, payload) {
    commit("SET_PIPELINE_LOADING", true);
    try {
      const response = await axios.put(domain + "/pipeline", payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PIPELINE", data);
      commit("SET_PIPELINE_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async savePipeline({ commit }, payload) {
    commit("SET_PIPELINE_LOADING", true);
    try {
      const response = await axios.post(domain + "/pipeline", payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PIPELINE", data);
      commit("SET_PIPELINE_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async saveSousPipeline({ commit }, payload) {
    commit("SET_PIPELINE_LOADING", true);
    try {
      const response = await axios.post(domain + "/pipeline/sous-pipeline", payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PIPELINE_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async saveTask({ commit }, payload) {
    commit("SET_PIPELINE_LOADING", true);
    try {
      const response = await axios.post(domain + "/pipeline/task", payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PIPELINE_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async updateTask({ commit }, payload) {
    commit("SET_PIPELINE_LOADING", true);
    const taskId = payload?.id ?? payload;
    const body = { sous_pipeline_id: payload?.sous_pipeline_id };
    try {
      const response = await axios.put(domain + "/pipeline/task/" + taskId, body, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_PIPELINE_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async loadPipelinesForFormFromProcessus({ commit, dispatch }, { processus_id, entreprise_id }) {
    if (!processus_id) return;
    try {
      const data = await dispatch("getPipeline", {
        processus_id,
        entreprise_id: entreprise_id ?? undefined,
      });
      let list = [];
      if (data) {
        if (Array.isArray(data.pipelines)) list = data.pipelines;
        else if (Array.isArray(data.columns)) list = data.columns;
        else if (Array.isArray(data.data)) list = data.data;
        else if (Array.isArray(data) && data[0]?.pipelines) list = data[0].pipelines;
        else if (Array.isArray(data)) list = data;
      }
      commit("SET_PIPELINES_FOR_FORM", list);
      return list;
    } catch (e) {
      commit("SET_PIPELINES_FOR_FORM", []);
      throw e;
    }
  },
  async fetchPipelinesForForm({ commit }, payload = {}) {
    const params = {};
    if (payload.entreprise_id != null) params.entreprise_id = payload.entreprise_id;
    if (payload.operation != null) params.operation = payload.operation;
    if (payload.processus_id != null) params.processus_id = payload.processus_id;
    try {
      const response = await axios.get(domain + "/pipeline/data", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      const raw = response.data?.data ?? response.data;
      let list = [];
      if (raw) {
        if (Array.isArray(raw)) list = raw;
        else if (Array.isArray(raw.data)) list = raw.data;
        else if (Array.isArray(raw.pipelines)) list = raw.pipelines;
        else if (Array.isArray(raw.columns)) list = raw.columns;
      }
      commit("SET_PIPELINES_FOR_FORM", list);
      return list;
    } catch (error) {
      commit("SET_PIPELINES_FOR_FORM", []);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async deleteTask({ commit }, taskId) {
    commit("SET_PIPELINE_LOADING", true);
    try {
      await axios.delete(domain + "/pipeline/task/" + taskId, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_PIPELINE_LOADING", false);
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async deletePipeline({ commit }, pipelineId) {
    commit("SET_PIPELINE_LOADING", true);
    try {
      await axios.delete(domain + "/pipeline/" + pipelineId, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_PIPELINE_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
  async deleteSousPipeline({ commit }, sousPipelineId) {
    commit("SET_PIPELINE_LOADING", true);
    try {
      await axios.delete(domain + "/pipeline/sous-pipeline/" + sousPipelineId, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_PIPELINE_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_PIPELINE_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
